import React from 'react'
import ProcessTabContainer from './ProcessTabContainer'

function ProcessPage() {
  return (
   <>
   <div className="container container-xxl">
    <div className="pagetitle">
        <h1><i className="bi bi-list-task"></i>Process</h1>
    </div>
        <ProcessTabContainer/>
   </div>
   
   </>
  )
}

export default ProcessPage